// keyboard event keycode lookups
export const digitKeys = (function () {
    return [0, 1, 2, 3, 4, 5, 6, 7, 8, 9].reduce( ( acc, next ) => {
        acc[next] = true;
        return acc;
    }, {} );
})();

export const specialKeys = {
    '0': 'other',
    '8': 'delete',
    '13': 'enter'
};

export const arrowKeys = {
    '38': 'up',
    '39': 'right',
    '40': 'down',
    '37': 'left'
};

export const metaKeys = {
    '17': 'ctrl',
    '18': 'alt',
    '91': 'meta'
};

// todo: export default object containing aliases for individual keys e.g. keycode.CTRL_KEY
// export default {};
